import { PILLAR } from "../../enums/metrics";
import type { MetricDef } from "./types";

/** Worker-owned instrument metrics: measured, not checklist-scored by the agent. */
export const INSTRUMENT_METRICS = [
  {
    key: "cwv",
    label: "Core Web Vitals",
    pillar: PILLAR.PERFORMANCE,
    target: 90,
    good: 75,
    watch: 50,
    description:
      "Google's Core Web Vitals: loading (LCP), visual stability (CLS) and input responsiveness (INP). Approximates how fast and steady the page feels to a real visitor. Scored against field thresholds, not lab.",
  },
] as const satisfies readonly MetricDef[];
